import moment from "moment/moment";
import 'moment/locale/fa';

export const agoDate = (date, locale = "fa") => {
    return moment(date).local(locale).fromNow();
}

export const formatDate = (date, locale = "fa") => {

    if (!date) return date;

    return new Date(date).toLocaleDateString('fa-IR');
}

export function toJalaliYYYYMMDD(dateStr) {
    if (!dateStr) {
        return null
    }

    try {
        const date = new Date(dateStr);
        const faDateParts = new Intl.DateTimeFormat('fa-IR-u-ca-persian', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit'
        }).formatToParts(date);

        const parts = {};
        faDateParts.forEach(({type, value}) => {
            if (type !== 'literal') {
                parts[type] = value;
            }
        });
        const toEnglishDigits = str => str.replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d));

        const year = toEnglishDigits(parts.year);
        const month = toEnglishDigits(parts.month);
        const day = toEnglishDigits(parts.day);

        return `${year}${month}${day}`;

    } catch (e) {
        return null
    }

}

export function getCurrentTimestamp() {
    return new Date().toISOString().replace("Z", "000000Z");
}

export function currentDate() {
    let today = new Date();

    let dd = today.getDate();
    let mm = today.getMonth();
    let yyyy = today.getFullYear();
    let h = today.getHours();
    let m = today.getMinutes();
    let s = today.getSeconds();

    if (dd < 10) {
        dd = '0' + dd;
    }
    if (mm < 10) {
        mm = '0' + mm;
    }

    if (h < 10) {
        h = '0' + h;
    }
    if (m < 10) {
        m = '0' + m;
    }

    if (s < 10) {
        s = '0' + s;
    }

    today = yyyy + '-' + mm + '-' + dd + ' ' + h + ':' + m + ':' + s;
    return today
}

export function minutes_to_HHMM(numberOfMinutes) {
    var duration = moment.duration(numberOfMinutes, 'minutes');
    var hh = (duration.years() * (365 * 24)) + (duration.months() * (30 * 24)) + (duration.days() * 24) + (duration.hours());
    var mm = duration.minutes();
    return hh.toString().padStart(2, '0') + ':' + mm.toString().padStart(2, '0');
}


export function current_hours_and_minutes() {
    // Get current date/times
    const now = new Date();

// Get hours and minutes
    const hours = now.getHours();
    const minutes = now.getMinutes();

// Format to ensure two digits (e.g., 9 becomes 09)
    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

// Combine into HH:MM format
    return `${formattedHours}:${formattedMinutes}`;

}


export function current_hours() {

    const now = new Date();
    const hours = now.getHours();
    const formattedHours = hours.toString().padStart(2, '0');
    return `${formattedHours}`;

}


export function progressBetweenDates(startDate, endDate) {
    const start = new Date(startDate);
    const end = new Date(endDate);
    const today = new Date();

    const total = end - start;
    const elapsed = today - start;
    const remaining = end - today;

    let percentElapsed = (elapsed / total) * 100;
    let percentRemaining = (remaining / total) * 100;

    percentElapsed = Math.max(0, Math.min(100, percentElapsed));
    percentRemaining = Math.max(0, Math.min(100, percentRemaining));

    return {
        elapsedDays: Math.max(0, Math.floor(elapsed / (1000 * 60 * 60 * 24))),
        remainingDays: Math.max(0, Math.ceil(remaining / (1000 * 60 * 60 * 24))),
        percentElapsed: percentElapsed.toFixed(2),
        percentRemaining: percentRemaining.toFixed(2)
    };
}
